import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from '../types';
import { pageData } from './pageData';
import { campaignData } from './campaignData';
import { jobData } from './jobData';
import { joblistData } from './joblistData';
import { contactData } from './contactData';
import { investData } from './investData';
import { workData } from './workData';
import { newsData } from './newsData';
import { productData } from './productData';
import { menuData } from './menu';
import { rmenuData } from './rtmenu';
import { socialData } from './socialData';
import { globalData } from './global';
import { brandData } from './brandData';
import animationData from './animaion';
import { settingData } from './settingData';

Vue.use(Vuex);

const store: StoreOptions<RootState> ={
    state: {
        version: "0.1.0"
    },
    modules: {
        pageData,
        campaignData,
        jobData,
        joblistData,
        contactData,
        investData,
        workData,
        newsData,
        productData,
        menuData,
        rmenuData,
        socialData,
        globalData,
        brandData,
        animationData,
        settingData
    }
};

export default new Vuex.Store<RootState>(store);

